import actionTypes from 'reduxStore/actionTypes'
import { modalTypes } from 'reduxStore/reducers/compCtrl'

function setUserAction(user) {
  return {
    type: actionTypes.SET_USER,
    data: user,
  }
}

function clearUserAction() {
  return {
    type: actionTypes.CLEAR_USER,
  }
}

function loadShopOpenTimeAction(list) {
  return {
    type: actionTypes.LOAD_SHOP_OPEN_TIME,
    data: list,
  }
}

function setAdminAction(admin) {
  return {
    type: actionTypes.SET_ADMIN,
    data: admin,
  }
}

function clearAdminAction() {
  return {
    type: actionTypes.CLEAR_ADMIN,
  }
}

function controlModalAction(modalType, active) {
  return {
    type: active ? actionTypes.OPEN_MODAL : actionTypes.CLOSE_MODEL,
    modalType,
  }
}
controlModalAction.modalTypes = {
  ...modalTypes,
}

export {
  setUserAction,
  clearUserAction,
  loadShopOpenTimeAction,
  setAdminAction,
  clearAdminAction,
  controlModalAction,
}
